import { IStyleProps, mergeStyles } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IUser } from '../../../../types/user';
import { Button } from '../../button';

const style = require('./index.css');

export interface ILikeButtonProps {
  isActive: boolean;

  buttonClassName?: string;
  buttonStyle?: IStyleProps;

  toggleActivity(value: boolean): void;
}

export interface ILikeButtonContext {
  user: IUser;
  api: {
    favoritesLimitForUnauthUser?: number;
  };
}

export interface ILikeButtonState {
  isActive: boolean;
}

const DEFAULT_FAVORITES_LIMIT_FOR_UNAUTH_USER = 3;

export class LikeButton extends React.Component<ILikeButtonProps, ILikeButtonState> {
  public context: ILikeButtonContext;

  public static contextTypes = {
    api: PropTypes.object,
    user: PropTypes.object,
  };

  public constructor(props: ILikeButtonProps) {
    super(props);

    this.state = {
      isActive: props.isActive,
    };
  }

  public render() {
    return (
      <Button
        theme="primary"
        mode="light"
        {...mergeStyles(
          style['button'],
          this.props.buttonClassName || '',
          // tslint:disable-next-line:no-any
          !this.state.isActive && this.props.buttonStyle as any,
        )}
        onClick={this.handleClick}
      >
        <svg
          {...mergeStyles(
            style['icon'],
            this.state.isActive && style['icon--active'],
          )}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14.004 14"
          width="14"
          height="14"
        >
          {/* tslint:disable-next-line:max-line-length */}
          <path stroke="#E84260" strokeWidth="2" d="M6.99 11.72L1.825 6.677C.727 5.582.725 3.805 1.82 2.707l.015-.015c1.118-1.08 2.962-1.08 4.092.014l.36.35.67.648.694-.62.394-.35.03-.028c1.13-1.095 2.973-1.095 4.104 0 1.1 1.093 1.103 2.87.01 3.968l-.015.015-5.182 5.03z" />
        </svg>
        {this.state.isActive ? 'В избранном' : 'В избранное'}
      </Button>
    );
  }

  protected handleClick = () => {
    // tslint:disable-next-line:no-any
    const currentCount = (window as any).__header_favorites_count__ || 0;
    const { user, api: { favoritesLimitForUnauthUser = DEFAULT_FAVORITES_LIMIT_FOR_UNAUTH_USER } } = this.context;

    if (
        this.state.isActive
        || user.isAuthenticated
        || currentCount < favoritesLimitForUnauthUser
        // tslint:disable-next-line:no-any
        || !(window as any).waitForLoginPopup
    ) {
      this.setState({
        isActive: !this.state.isActive,
      });
    }

    this.props.toggleActivity(!this.state.isActive);
  }
}
